import React, { useState } from "react";
import { Grid, Container } from "@mui/material";
import SideBarLinks from "../../shared/customers/sidebar/SideBarLinks";
import SideLinks from "../../shared/customers/sidebar/SideLinks";
import TransactionsPaid from "./TransactionsPaid";
import TransactionsUnPaid from "./TransactionsUnPaid";
import {
  TranLayoutWrapper,
  LayoutWrap,
  ContactMain,
} from "./styles/TranLayoutMianStyle";
import { useDispatch, useSelector } from "react-redux";
import { SetProfileMobileSidebar } from "../../../redux/slice/common/CommonSlice";

const TranLayoutMian = () => {
  const [selectedLink, setSelectedLink] = useState(0);
  const dispatch = useDispatch();
  const GetSidebarState = useSelector(
    (state) => state.common.ProfileMobileSidebar
  );
  const links = [{ label: "Paid" }, { label: "Unpaid" }];
  const handleLinkClick = (link) => {
    setSelectedLink(link);

    dispatch(SetProfileMobileSidebar(!GetSidebarState));
  };

  return (
    <>
      <TranLayoutWrapper>
        <Container maxWidth="lg">
          <LayoutWrap>
            <Grid container spacing={3}>
              <Grid item xs={12} md={3} lg={3}>
                <SideBarLinks>
                  <SideLinks
                    links={links}
                    selectedLink={selectedLink}
                    onLinkClick={handleLinkClick}
                  />
                </SideBarLinks>
              </Grid>
              <Grid item xs={12} md={9} lg={9}>
                <ContactMain>
                  {selectedLink === 0 && <TransactionsPaid />}
                  {selectedLink === 1 && <TransactionsUnPaid />}
                </ContactMain>
              </Grid>
            </Grid>
          </LayoutWrap>
        </Container>
      </TranLayoutWrapper>
    </>
  );
};

export default TranLayoutMian;
